export default "__VITE_ASSET__8af41f6f__"